

interface BottomDockProps {
  isPresenceOpen: boolean;
  onTogglePresence: () => void;
  socketStatus: "connected" | "reconnecting" | "disconnected";
}

export default function BottomDock({
  isPresenceOpen,
  onTogglePresence,
  socketStatus,
}: BottomDockProps) {
  return (
    <div className="glass-panel bottom-hud-dock">
      {/* Drawer Toggle */}
      <button
        className={`dock-btn ${isPresenceOpen ? "active" : ""}`}
        onClick={onTogglePresence}
        title={isPresenceOpen ? "Hide Members Drawer" : "Show Members Drawer"}
      >
        👥
      </button>

      <div className="dock-divider" />

      {/* WebRTC Placeholders (to expand with LiveKit calls later) */}
      <button
        className="dock-btn"
        onClick={() => alert("Microphone controls coming soon with LiveKit integrations!")}
        title="Mute / Unmute"
      >
        🎙️
      </button>

      <button
        className="dock-btn"
        onClick={() => alert("Camera controls coming soon with LiveKit integrations!")}
        title="Toggle Camera"
      >
        📹
      </button>

      <button
        className="dock-btn"
        onClick={() => alert("Screen share coming soon with LiveKit integrations!")}
        title="Share Screen"
      >
        🖥️
      </button>

      <div className="dock-divider" />

      {/* Socket status badge */}
      <div className="status-pill">
        <span
          className={`status-badge status-${socketStatus}`}
          style={{ margin: 0 }}
        />
        <span style={{ textTransform: "capitalize" }}>
          {socketStatus === "connected" ? "Sync Active" : socketStatus}
        </span>
      </div>
    </div>
  );
}
